import React from "react";
import { Avatar } from "@mui/material";

const UserValuation = ({ activity }) => {
  return (
    <>
      {activity.length > 0 ? (
        <>
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr>
                <th className="">User</th>
                <th className="">Report Title</th>
                <th className=""> Generated</th>
                <th className="">Time</th>
              </tr>
            </thead>
            {activity.map((res, i) => (
              <tr key={i} className="my-2 pt-2">
                <td className=" my-2 pt-2">
                  <Avatar src={res.user ? res.user.avatar : ""} />
                  {res.user ? `${res.user.name} (${res.user.type})` : ""}
                </td>
                <td className=" my-2 pt-2">
                  {res.reportGenerated ? res.reportTitle : res.companyName}
                </td>

                <td className=" my-2 pt-2  p-2">
                  {res.reportGenerated ? (
                    <p
                      style={{
                        color: "green",
                        padding: "10px",
                      }}
                    >
                      Generated
                    </p>
                  ) : (
                    <p style={{ color: "red" }}>Pending</p>
                  )}
                </td>

                <td className=" p-2">
                  {new Date(res.createdAt).toLocaleTimeString()}{" "}
                  {new Date(res.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default UserValuation;
